import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { globalData } from 'global/js/globalData';
import * as Actions from 'containers/Home/actions';
import * as PulseCheckActions from './actions';
import Header from 'components/Header/Header';
import Navigation from 'components/Navigation/Navigation';
import Question from 'components/Question/Question';
import StarRadioButtonList from 'components/StarRadioButtonList/StarRadioButtonList';
import StayName from 'components/StayName/StayName';
import TextArea from 'components/TextArea/TextArea';

class PulseCheck extends Component {
    constructor(props) {
        super(props);
    }

    /**
     * Updates the state with the value of the textarea comment.
     *
     * @param     value : String
     */
    handleChange = (value) => {
        this.props.pulseCheckActions.setPulseCheckComment(value);
    }

    render() {
        const surveyData = this.props.surveyData;
        const locationIndex = this.props.locationIndex;
        const currentQuestion = surveyData.StaySubmissions[locationIndex].PulseCheck;
        const questionText = currentQuestion.Text;
        const questionAnswer = currentQuestion.AnswerRating;
        const questionSubText = currentQuestion.SubText;
        const questionComment = currentQuestion.AnswerComment;

        return (
            <section className='wrapper pulse-check'>
                {surveyData.IsBackup && (
                    <Header locationIndex={locationIndex} stays={surveyData.StaySubmissions} />
                )}

                <div className='container'>
                    <StayName locationIndex={locationIndex} stays={surveyData.StaySubmissions} />

                    <div className='content'>
                        <Question questionText={questionText} />

                        <StarRadioButtonList 
                            answerValue={questionAnswer}
                            handleClick={this.props.pulseCheckActions.setStarRatingValue}
                        />

                        <Question questionText={questionSubText} />

                        <TextArea 
                            handleChange={this.handleChange} 
                            placeholderText={globalData.pulseCheckPlaceholder}
                            textValue={questionComment} 
                        />

                        <Navigation
                            actions={this.props.actions}
                            answerValue={questionAnswer}
                            individualID={this.props.individualID}
                            locationIndex={this.props.locationIndex}
                            nextLink='/Components' 
                            prevLink='/'
                            prodTourID={this.props.prodTourID}
                            surveyData={this.props.surveyData}
                        />
                    </div>
                </div>
            </section>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        individualID: state.dataReducer.individualID,
        locationIndex: state.surveyReducer.locationIndex,
        prodTourID: state.dataReducer.prodTourID,
        surveyData: state.surveyReducer.surveyData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Actions, dispatch),
        pulseCheckActions: bindActionCreators(PulseCheckActions, dispatch)
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PulseCheck));



// WEBPACK FOOTER //
// ./application/containers/PulseCheck/PulseCheck.jsx